import React from "react";

export default function MSAccess_Now() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Now</h1>
      <p>This is the MSAccess_Now component generated from the SQL JSON.</p>
    </div>
  );
}
